import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useData } from '../../context/DataContext';
import { useAuth } from '../../context/AuthContext';
import TasksReport from './TasksReport';
import TeamReport from './TeamReport';
import ClientsReport from './ClientsReport';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiBarChart3, FiDownload } = FiIcons;

const Reports = () => {
  const { tasks, clients, teamMembers } = useData();
  const { hasPermission } = useAuth();
  const [activeTab, setActiveTab] = useState('tasks');

  if (!hasPermission('view_reports') && !hasPermission('all')) {
    return (
      <div className="text-center py-12">
        <SafeIcon icon={FiBarChart3} className="w-16 h-16 text-gray-300 mx-auto mb-4" />
        <h3 className="text-lg font-medium text-gray-900 mb-2">Access Restricted</h3>
        <p className="text-gray-600">
          You don't have permission to view reports.
        </p>
      </div>
    );
  }

  const tabs = [
    { id: 'tasks', name: 'Tasks', component: TasksReport },
    { id: 'team', name: 'Team Performance', component: TeamReport },
    { id: 'clients', name: 'Clients & Sales', component: ClientsReport }
  ];

  const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Reports & Analytics</h1>
          <p className="text-gray-600 mt-1">
            Comprehensive insights into your team's performance and business metrics
          </p>
        </div>

        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          className="flex items-center space-x-2 bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors"
        >
          <SafeIcon icon={FiDownload} className="w-5 h-5" />
          <span>Export Report</span>
        </motion.button>
      </div>

      {/* Tab Navigation */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200">
        <div className="flex border-b border-gray-200">
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`px-6 py-4 text-sm font-medium transition-colors ${
                activeTab === tab.id
                  ? 'text-blue-600 border-b-2 border-blue-600 bg-blue-50'
                  : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              {tab.name}
            </button>
          ))}
        </div>

        <div className="p-6">
          {ActiveComponent && (
            <motion.div
              key={activeTab}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
            >
              <ActiveComponent 
                tasks={tasks}
                clients={clients}
                teamMembers={teamMembers}
              />
            </motion.div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Reports;